<template lang="pug">
.v-title.title(v-if="title")
	.title__wrapper
		button.title__button(v-if="isSm" @click="goBack")
			v-svg-icon.title__icon(icon="back-arrow")
		h1.title__text {{title}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		title: {
			type: String,
			default: null
		}
	},

	methods: {
		goBack() {
			window.history.back();
		}
	}
};
</script>